import * as React from 'react'
import { useState } from 'react'
import { format } from 'date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { DatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

import { Input } from '@metrisk/react_metrisk-components'

import './DatePicker.scss'

const CustomInput = ({ name, value, inputRef, InputProps, onClick, ...other }: any) => {
  return <Input ref={inputRef} name={name} value={value} onClick={onClick} {...InputProps} />
}

const DatePickerInput = ({ name, onChange }: any) => {
  const [dateValue, setDateValue] = useState(null)
  const handleChange = (value: Date) => {
    setDateValue(value)
    onChange(format(value, 'yyyy-MM-dd'))
  }
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker name={name} value={dateValue} onChange={handleChange} TextFieldComponent={CustomInput} />
    </MuiPickersUtilsProvider>
  )
}

export default DatePickerInput
